import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "@emotion/styled";
import { Container } from "../Container";
import { useElementsContext } from "../elementsProvider";
function ImageWrapper({ href, children }) {
    if (href !== "") {
        return (_jsx(Link, Object.assign({ target: "_blank", href: href }, { children: children }), void 0));
    }
    return children;
}
export function RTCImage3Gallery({ image1src, image1url, image2src, image2url, image3src, image3url, skin = "1", }) {
    const { isMobile } = useElementsContext();
    const images1 = JSON.parse(image1src);
    const images2 = JSON.parse(image2src);
    const images3 = JSON.parse(image3src);
    return (_jsx(ContainerStyled, Object.assign({ isDesktop: !isMobile }, { children: _jsxs(MetaContent, Object.assign({ isDesktop: !isMobile }, { children: [_jsx(ImageArticle, Object.assign({ "data-testid": "3gallery-image-1" }, { children: _jsx(ImageWrapper, Object.assign({ href: image1url }, { children: _jsx(Images, { src: images1.medium, alt: "Imagen 1" }, void 0) }), void 0) }), void 0),
                _jsx(ImageArticle, Object.assign({ "data-testid": "3gallery-image-2" }, { children: _jsx(ImageWrapper, Object.assign({ href: image2url }, { children: _jsx(Images, { src: images2.medium, alt: "Imagen 2" }, void 0) }), void 0) }), void 0),
                _jsx(ImageArticle, Object.assign({ "data-testid": "3gallery-image-3" }, { children: _jsx(ImageWrapper, Object.assign({ href: image3url }, { children: _jsx(Images, { src: images3.medium, alt: "Imagen 3" }, void 0) }), void 0) }), void 0)] }), void 0) }), void 0));
}
const ContainerStyled = styled(Container)(({ isDesktop }) => (Object.assign({ alignItems: "center", display: "flex", flexDirection: "column" }, (isDesktop
    ? {
        height: "30rem",
    }
    : {}))));
const MetaContent = styled.div(({ isDesktop }) => (Object.assign({ alignItems: "center", display: "grid", gridGap: "1.6rem", gridTemplateRows: !isDesktop ? "30rem 30rem 30rem" : "unset", width: "30rem" }, (isDesktop
    ? {
        gridGap: "2rem",
        gridTemplateColumns: "30rem 30rem 30rem",
        gridAutoRows: "30rem",
        height: "30rem",
        width: "auto",
    }
    : {}))));
const Images = styled.img(() => ({
    height: "100%",
    objectFit: "cover",
    width: "100%",
}));
const Link = styled.a(() => ({
    height: "100%",
    width: "100%",
}));
const ImageArticle = styled.article({
    height: "100%",
});
//# sourceMappingURL=RTCImage3Gallery.js.map